// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0f7b4cbc] .el-dialog--center{width:40.625rem!important}.currentTab[data-v-0f7b4cbc]{background-color:#409eff;color:#fff;border:none}.tabItem[data-v-0f7b4cbc]{display:flex;justify-content:center;align-items:center;flex:1;border:.0625rem solid #ccc;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
